import { FC, PropsWithChildren } from 'react';

interface ModalFooterProps {
  className?: string;
}

export const ModalFooter: FC<PropsWithChildren<ModalFooterProps>> = ({
  children,
  className,
}) => {
  return (
    <div slot="footer" className={className}>
      {children}
    </div>
  );
};
